import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X, Download } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const ImageLightbox = ({ image, onClose }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!image) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [image, onClose]);

  if (!image) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[200] bg-black/90 flex items-center justify-center p-4 animate-in fade-in duration-150"
      onClick={onClose}
      data-testid="chat-lightbox"
      role="dialog"
      aria-modal="true"
    >
      <div className="absolute top-0 right-0 flex gap-2 p-3" style={{ paddingTop: 'max(0.75rem, env(safe-area-inset-top))' }}>
        <a
          href={image.src}
          download={image.name || true}
          onClick={(e) => e.stopPropagation()}
          data-testid="chat-lightbox-download"
          title={t('chat.download')}
          className="w-11 h-11 flex items-center justify-center rounded-full bg-white/15 hover:bg-white/30 text-white transition-colors"
        >
          <Download className="w-5 h-5" />
        </a>
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); onClose(); }}
          data-testid="chat-lightbox-close"
          title={t('chat.close')}
          className="w-11 h-11 flex items-center justify-center rounded-full bg-white/15 hover:bg-white/30 text-white transition-colors"
        >
          <X className="w-6 h-6" />
        </button>
      </div>
      <img
        src={image.src}
        alt={image.name || ''}
        onClick={(e) => e.stopPropagation()}
        data-testid="chat-lightbox-image"
        className="max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl"
      />
    </div>,
    document.body
  );
};

export default ImageLightbox;
